import {BankDetails} from '../components/Bank/BankDetails';
import {MessageAcceptTerms} from '../components/Messages/MessageAcceptTerms';
import {MessageAccreditationCancel} from '../components/Messages/MessageAccreditationCancel';
import {MessageAccreditationClose} from '../components/Messages/MessageAccreditationClose';
import {MessageAddress} from '../components/Messages/MessageAddress';
import MessageAddressFromBureau from '../components/Messages/MessageAddressFromBureau/';
import MessageAddressFromBureauComplementConfirm from '../components/Messages/MessageAddressFromBureauComplementConfirm';
import MessageAddressType from '../components/Messages/MessageAddressType';
import {MessageBankAccountCaixa} from '../components/Messages/MessageBankAccountCaixa';
import {MessageBankCaixa} from '../components/Messages/MessageBankCaixa/MessageBankCaixa';
import MessageBankList from '../components/Messages/MessageBankList';
import MessageCnpjNoInfoBureauConfirme from '../components/Messages/MessageCnpjNoInfoBureauConfirme';
import MessageDocumentsInfo from '../components/Messages/MessageDocumentsInfo';
import {MessageErrorIcon} from '../components/Messages/MessageErrorIcon';
import {MessageErrorTextLongIcon} from '../components/Messages/MessageErrorTextLongIcon';
import MessageFinishSimulation from '../components/Messages/MessageFinishSimulation/MessageFinishSimulation';
import {MessageHiIcon} from '../components/Messages/MessageHiIcon';
import MessagePartnersOwnerQuestion from '../components/Messages/MessagePartnersOwnerQuestion';
import MessagePartnersQuestions from '../components/Messages/MessagePartnersQuestions';
import {MessagePsrsEcommerce} from '../components/Messages/MessagePsrsEcommerce';
import {MessagePsrsPhysical} from '../components/Messages/MessagePsrsPhysical';
import {MessagePsrsTypeQuestion} from '../components/Messages/MessagePsrsTypeQuestion';
import MessageQuestion from '../components/Messages/MessageQuestion';
import {MessageQuestionAddress} from '../components/Messages/MessageQuestionAddress';
import {MessageQuestionPsrCodeConfirm} from '../components/Messages/MessageQuestionPsrCodeConfirm/MessageQuestionPsrCodeConfirm';
import {MessageQuestionPsrCodeEcommerceConfirm} from '../components/Messages/MessageQuestionPsrCodeEcommerceConfirm';
import MessageReceive from '../components/Messages/MessageReceive';
import MessageSent from '../components/Messages/MessageSent';
import {MessageStartIcon} from '../components/Messages/MessageStartIcon';

export const COMPONENTS_MAP = {
  default: ({message}) => (
    <MessageSent label={message.label} message={message}>
      {message.text}
    </MessageSent>
  ),
  'message-receive': ({message}) => (
    <MessageReceive label={message.label} message={message}>
      {message.text}
    </MessageReceive>
  ),
  'message-long-error-icon': ({message}) => (
    <MessageErrorTextLongIcon message={message} />
  ),
  'message-error-icon': ({message}) => (
    <MessageErrorIcon key={message.id} message={message} />
  ),
  'message-cancel-question': ({message}) => (
    <MessageAccreditationCancel question={message} />
  ),
  'message-hi-icon': ({message}) => <MessageHiIcon message={message} />,
  'message-receive-info-document': ({message}) => (
    <MessageDocumentsInfo label={message.label} message={message}>
      {message.text}
    </MessageDocumentsInfo>
  ),
  'message-start-icon': ({message}) => <MessageStartIcon message={message} />,
  'continue-question': ({message}) => <MessageQuestion question={message} />,
  'message-accreditation-close': ({message}) => (
    <MessageAccreditationClose question={message} />
  ),
  'cnpj-no-info-bureau-confirm': ({message}) => (
    <MessageCnpjNoInfoBureauConfirme key={message.id} question={message} />
  ),
  'question-are-you-the-owner': ({message}) => (
    <MessagePartnersOwnerQuestion question={message} />
  ),
  'partners-complete-question': ({message}) => (
    <MessagePartnersQuestions question={message} />
  ),
  'message-receive-address-icon': ({message}) => (
    <MessageQuestionAddress message={message}>
      {message.text}
    </MessageQuestionAddress>
  ),
  'start-addresses-flow': ({message}) => (
    <MessageAddressFromBureau
      content={message}
      step={'address' + message.index}
    />
  ),
  'show-address-question': ({message}) => <MessageAddress question={message} />,
  'address-from-bureau-complement-confirm': ({message}) => (
    <MessageAddressFromBureauComplementConfirm content={message} />
  ),
  'message-receive-address-type': ({message}) => (
    <MessageAddressType content={message} />
  ),
  'select-psr-type': ({message}) => (
    <MessagePsrsTypeQuestion question={message} />
  ),
  'select-psr-physical': ({message}) => (
    <MessagePsrsPhysical question={message} />
  ),
  'select-psr-ecommerce': ({message}) => (
    <MessagePsrsEcommerce question={message} />
  ),
  'bank-list-msg': ({message}) => (
    <MessageBankList message={message}>{message.text};</MessageBankList>
  ),
  'message-bank-caixa': ({message}) => <MessageBankCaixa question={message} />,
  'message-bank-account-caixa': ({message}) => (
    <MessageBankAccountCaixa question={message} />
  ),
  'set-account-bank-type': ({message}) => <BankDetails />,
  'terms-of-acceptance': ({message}) => (
    <MessageAcceptTerms question={message} />
  ),
  'chat-bot-finish': ({message}) => (
    <MessageFinishSimulation content={message} />
  ),
  'psr-code-confirm': ({message}) => (
    <MessageQuestionPsrCodeConfirm question={message} />
  ),
  'psr-code-confirm-ecommerce': ({message}) => (
    <MessageQuestionPsrCodeEcommerceConfirm question={message} />
  )
};
